import { GoogleSlides } from "assets/icons";
import { InformationSetting, RememberSettings } from "components/settings";
import { WidgetNames } from "constants/widgets";

import { TextAreaSettings } from "./components";
import { GoogleSlidesContainer } from "./GoogleSlides";

export const GoogleSlidesWidget: any = {
  name: "Google Slides",
  component: GoogleSlidesContainer,
  icon: GoogleSlides,
  showOnToolbar: true,
  sizing: {
    minWidth: 150,
    minHeight: 120,
    minAspectRatio: 0.5,
    maxAspectRatio: 1.5,
  },
  defaultState: {
    placeholder: "Add your embed code here...",
    hasError: false,
  },
  defaultSize: {
    aspectRatio: 2,
    widthPercentage: 30,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Insert your Google Slides link here. Please ensure your presentation is set to public",
      },
    },
    data: {
      editor: TextAreaSettings,
      info: {
        placeholder: "Add your embed code here...",
        settingName: "Embed code",
      },
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.googleSlides,
        widgetDisplayName: "Google Slides",
      },
    },
  },
  quickActions: {},
};
